// Animate in hero header on window load

window.addEventListener('load', event => {
    let header = document.getElementById('heroHeader');
    if (header) {
        setTimeout(function() {
            header.classList.remove('opacity-0', '-translate-y-2');
        }, 300);
    }
});